import axios from "axios";
import {appdata, save} from "../../logic_tmp/appdata/AppData";
import {calculateGeo, hash} from "../../components/model/utils";
import {getProfile, saveProfile} from "../../logic_tmp/storage/LgProfile";
import app from "../../App";

export function createLead() {
    appdata.geoText = calculateGeo()
    appdata.customerEmail = appdata.customerEmail.trim()

    return axios.post('https://api.duoclassico.eu/functions/lead', appdata).then(response => {
        if (response.status === 200) {
            appdata.country = response.data["country"];
            appdata.leadId = response.data["id"]
            save();
            let profile = getProfile()
            profile.customerId = appdata.customerEmail
            profile.customerName = appdata.customerName
            profile.customerPhone = appdata.customerPhone
            profile.leadId = appdata.leadId
            saveProfile()
        }
        return response
    })
}

export function logBack(params) {
    let url = "https://api.duoclassico.eu/functions/log?" + params
    console.log(url)
    return axios.get(url)
}

export function pingApi() {
    return axios.get('https://api.duoclassico.eu/functions/hello')
}

export function getCountersImpl() {
    let ticketBalanceConfig = appdata.product["ticketBalance"]
    return axios.get('https://api.duoclassico.eu/functions/counters')
        .then(response => {
            let cc1 = response.data["TOTAL.DELIVERED"];
            if (cc1 === undefined) cc1 = 0;
            if (ticketBalanceConfig === undefined) return 0;
            let cc = 1000000 - cc1 +  hash(appdata.productCode)
            cc = cc - (new Date().getDate()) * 2;
            cc = cc % 6 + 3;
            return cc;

        })
        .catch((error) => {
            return Promise.reject(error)
        })
        .finally(() => {
        });
}

export function init() {
    appdata.geoText = calculateGeo()

    return axios.post('https://api.duoclassico.eu/functions/init', appdata).then(response => {

        if (response.status === 200) {
            appdata.orderId = response.data["orderId"];
            appdata.redirectData = response.data["redirectData"];
            save();
        }
        return response
    })
}


